import React, { useMemo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { isEqual } from 'lodash';
import { Form, Input, notification, Row } from 'antd';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  getEntityFollowUpByCtriteria,
  EntityFollowUpResponse,
  runEntityFollowUp,
  GetEntityFollowUpByCtriteriaParams,
} from 'services/workflow';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ProposalSelect from 'components/ProposalSelect';
import AssetSelect from 'components/AssetSelect';
import SupplierInvoiceSelect from 'components/SupplierInvoiceSelect';
import GuarantySelect from 'components/GuarantySelect';
import CollectionSelect from 'components/CollectionSelect';
import ModalController from 'components/ModalController';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import GuarantDetailModal from 'pages/guaranty/guarantyDetails/guarantyDetailsModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import AssetDetails from 'pages/Asset/AssetDetail';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import PaymentSelect from 'components/PaymentSelect';
import ClientInvoiceSelect from 'components/ClientInvoiceSelect';
import ScoringSelect from 'components/ScoringSelect';
import DocSelect from 'components/DocSelect';
import PoSelect from 'components/POSelect';
import PayementModal from 'pages/Payment/PayementModal';
import ScoringModal from 'pages/Scoring/ScoringDetail/ScoringModal';
import ButtonOperation from 'components/ButtonOperation';

type Values = {
  followup: EntityFollowUpResponse[];
};

const EntityFollowup = () => {
  const [form] = Form.useForm();

  const fieldName = 'processfollowup';

  const [Params, setParams] = useState<any>({
    previewVisibleDOC: false,
  });

  const handlePreviewDOC = (fileurl: any) => {
    setParams({
      previewVisibleDOC: true,
    });
  };
  const [checkdocmodule, setcheckdocmodule] = useState('');

  const intValueSearch: GetEntityFollowUpByCtriteriaParams = {
    action: '',
    entity: '',
    entityid: '' as any,
    status: '',
  };

  const [searchParams, setSearchParams] =
    useState<GetEntityFollowUpByCtriteriaParams>(intValueSearch);

  const [searchs, setsearchs] = useState(false);

  let { data, refetch, isFetching } = useQuery(
    ['getEntityFollowUpByCtriteria', searchParams],
    () =>
      getEntityFollowUpByCtriteria(searchParams).then((res) => res.list || []),
    {
      enabled: searchs,
    }
  );
  const EntityFollowUpRunManual = (item: any) => {
    runEntityFollowUp({
      action: item.action,
      entity: item.entity,
      entityid: item.entityid,
      id: item.id,
      taskid: item.taskid,
      requestParam: {
        comment: '',
        entity: item.entity,
        entityId: item.entityId,
        externalreference: '',
        gridid: 0,
        jobid: 0,
        pardate: '',
        parvalue: '',
        phase: '',
        stage: '',
        status: item.status,
        taskid: item.taskid,
        tpid: 0,
        tprole: '',
      },
    }).then((response) => {
      if (response.message === '200') {
        notification.success({
          message: `${item.entity}-${item.entityreference}  successfully created`,
        });
        refetch();
      }
    });
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ [fieldName]: data });
    }
  }, [form, data]);

  const columns = useMemo<DataGridColDef<EntityFollowUpResponse>[]>(
    () => [
      {
        dataIndex: 'entitylabel',
        filtrable: 'entity',
        filterComponent: (
          <ParListSelect
            onClear={() => {
              form.resetFields();
            }}
            allowClear
            parcode="WFENTITY"
            onSelect={(e) => {
              setcheckdocmodule(e);
            }}
          />
        ),
        width: '100px',
      },
      {
        comcode: 'entityreference',
        dataIndex: 'entityid',
        filtrable: true,
        filterComponent:
          checkdocmodule === 'THIRDPARTY' ? (
            <ThirdPartyInput onlytpid />
          ) : checkdocmodule === 'PROPOSAL' ? (
            <ProposalSelect onlyctrid />
          ) : checkdocmodule === 'ASSET' ? (
            <AssetSelect onlyAssetId />
          ) : checkdocmodule === 'SINVOICE' ? (
            <SupplierInvoiceSelect onlysiid />
          ) : checkdocmodule === 'CONTRACT' ? (
            <ProposalSelect onlyctrid phase="ACTIVE" />
          ) : checkdocmodule === 'GUARANTY' ? (
            <GuarantySelect onlyGuarid />
          ) : checkdocmodule === 'CINVOICE' ? (
            <ClientInvoiceSelect onlyCiid />
          ) : checkdocmodule === 'PAYMENT' ? (
            <PaymentSelect onlyPayid />
          ) : checkdocmodule === 'SCORING' ? (
            <ScoringSelect onlyScoid />
          ) : checkdocmodule === 'DOCUMENT' ? (
            <DocSelect onlyDocid />
          ) : checkdocmodule === 'PURORDER' ? (
            <PoSelect onlyPoid />
          ) : checkdocmodule === 'COLLECTION' ? (
            <CollectionSelect onlyColid />
          ) : (
            <Input disabled defaultValue="Please select an object" />
          ),

        width: 100,
        render: (value, record) => (
          <div>
            <ModalController>
              {({ setVisible, visible }) => (
                <>
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.entityreference}
                  </a>
                  {record.entity === 'THIRDPARTY' ? (
                    <ThirdPartyModal
                      tpId={Number(record.entityid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.entity === 'PROPOSAL' ? (
                    <ProposalModal
                      ctrid={Number(record.entityid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.entity === 'ASSET' ? (
                    <AssetDetails
                      assetid={Number(record.entityid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                      phaseprop="PROPOSAL"
                      iscreate={false}
                    />
                  ) : record.entity === 'SIDetail' ? (
                    <SIDetail
                      siid={Number(record.entityid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                      showButtons={false}
                    />
                  ) : record.entity === 'CONTRACT' ? (
                    <ProposalModal
                      ctrid={Number(record.entityid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.entity === 'GUARANTY' ? (
                    <GuarantDetailModal
                      guarId={String(record.entityid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.entity === 'CINVOICE' ? (
                    <CIDetail
                      ciid={Number(record.entityid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                    />
                  ) : record.entity === 'PAYMENT' ? (
                    <PayementModal
                      payid={Number(record.entityid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      hideButtons
                      visible={visible}
                    />
                  ) : record.entity === 'SCORING' ? (
                    <ScoringModal
                      scoid={String(record.entityid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                    />
                  ) : (
                    ''
                  )}
                </>
              )}
            </ModalController>
          </div>
        ),
      },
      {
        dataIndex: 'tasklabel',
        width: 100,
      },
      {
        dataIndex: 'actionlabel',
        filtrable: true,
        filterComponent: <ParListSelect parcode="EFACTION" allowClear />,
        width: 100,
      },
      {
        dataIndex: 'taskid',
        width: 100,
      },
    
      {
        dataIndex: 'username',
        width: 100,
      },
      {
        comcode: 'statuslabel',
        dataIndex: 'status',
        filtrable: true,
        filterComponent: <ParListSelect parcode="ENTITYSTS" allowClear />,
        width: 100,
        render: (value, record) => record.statuslabel,
      },
      {
        dataIndex: 'actiondate',
        width: 100,
      },
      {
        dataIndex: 'action',
        width: 150,
        fixed: 'right',
        render: (text, record) => (
          <Row gutter={3}>
            {(record.status === 'INIT' ||
              record.status === 'INPROGRES') && (
                <ButtonOperation
                  onClick={() => EntityFollowUpRunManual(record)}
                  comcode="runentityfollowup"
                  type="primary"
                  htmlType="submit"
                />
              )}
          </Row>
        ),
      },
    ],

    [refetch, handlePreviewDOC, Params.handlePreviewDOC,]
  );

  return (
    <DF.Provider pagcode="entityfollowup">
      <Form form={form}>
        <Form.Item
          noStyle
          shouldUpdate={(prevValue: Values, nextValue: Values) => {
            return !isEqual(prevValue, nextValue);
          }}
        >
          {({ getFieldValue }) => {
            // eslint-disable-next-line no-unused-vars
            const followup: EntityFollowUpResponse[] = getFieldValue(fieldName);
            return (
              <DataGrid
                rowKey="id"
                dataSource={data}
                titleComcode="EntityFollowUpList"
                columns={columns}
                onSearch={(values) => {
                  setSearchParams({
                    ...searchParams,
                    ...values,
                    entity: values.entity,
                    entityid: values.entityid,
                  });
                  setsearchs(true);

                  refetch();
                }}
                onClear={() => {
                  setSearchParams(intValueSearch);
                  form.resetFields();
                  refetch();
                }}
                initialSearchValues={searchParams}
                isLoading={isFetching}
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default EntityFollowup;
